
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/products/[slug]/similar",
      function () {
        return require("private-next-pages/products/[slug]/similar.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/products/[slug]/similar"])
      });
    }
  